import { IconProps } from "../types/icon";

export const MoonIcon = ({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="M5.2 2C2.2 2.8 0 5.6 0 8.9 0 12.8 3.2 16 7.1 16c3.3 0 6-2.2 6.9-5.2C8.7 12.2 3.8 7.3 5.2 2M10 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
        <path d="M10 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      </g>
    </svg>
  );
};
